import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { Tooltip } from '@mui/material';

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.companyCode.getAllActive,
            "companyCodeDispValue",
            "companyCodeDispValue",
        ),
    ]);
    return {
        companyCode: dropdown[0],
    };
}

export const newRow = {
    companyCode:"",
    accountNo:"",
    description:"",
    shortDesc:"",
    status:false,
}